import script from "./GeminiModelForMobileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeminiModelForMobileView.vue?vue&type=script&setup=true&lang=ts"

import "./GeminiModelForMobileView.vue?vue&type=style&index=0&id=5f30f88d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f30f88d"]])

export default __exports__